<div *ngIf="isConnected && !ispageTypeLoginPath ; else loginPage">
  <mat-sidenav-container fullscreen class="mainContainer">
    <mat-sidenav #sidenav mode="over" class="app-sidenav">
      <div class="menuToolbar">
        <mat-toolbar class="matToolBar">
          <span class="toolbar-filler">Menu</span>
        </mat-toolbar>
        <mat-nav-list>
          <div *ngFor="let item of listItems">
            <span *ngIf="item.icon != '' else noIconMenu">
              <mat-list-item class="sidenav-link" (click)="sidenav.toggle()" [routerLink]="[item.pageLink]">
                <mat-icon matListItemIcon>{{item.icon}}</mat-icon>
                <h4 matListItemTitle>{{item.title}}</h4>
                <p matListItemLine>{{item.subTitle}}</p>
              </mat-list-item>
            </span>
            <ng-template #noIconMenu>
              <mat-list-item class="sidenav-link" (click)="sidenav.toggle()" [routerLink]="[item.pageLink]">
                <h4 matListItemTitle>{{item.title}}</h4>
                <p matListItemLine>{{item.subTitle}}</p>
              </mat-list-item>
            </ng-template>
            <mat-divider *ngIf="item.divider"></mat-divider>
          </div>
          <!-- div deconnexion -->
          <div class="bottom-menu">
            <a mat-list-item class="sidenav-link" (click)="sidenav.toggle()" routerLink="/mentions-legales">
              <mat-icon matListItemIcon>gavel</mat-icon>
              <span class="title" matListItemTitle>Mentions légales</span>
            </a>
            <a mat-list-item class="sidenav-link" (click)="logout()">
              <!-- <span class="title" mat-line>{{item.title}}</span>-->
              <mat-icon matListItemIcon>power_settings_new</mat-icon>
              <span class="title" matListItemTitle>Déconnexion</span>
            </a>
          </div>
        </mat-nav-list>
      </div>
    </mat-sidenav>
    <mat-sidenav-content class="mat-sidenav-content-cust">
      <mat-toolbar class="appToolbar" color="primary">
        <button mat-icon-button (click)="sidenav.toggle()" class="mat-icon-button sidenav-toggle-button"
          [hidden]="sidenav.opened">
          <mat-icon>menu</mat-icon>
        </button>
        <h1 class="component-title">
          <a class="title-link">{{currentPage}}
            <ng-container *ngIf="currentPage == 'Pointage'"> des appels à support</ng-container>
          </a>
        </h1>
        <span class="toolbar-filler"></span>
        <span class="user-name">
          {{userLogin}}
        </span>

        <span class="toolBarRight">
          <img [src]="imgLogo" class="right-logo-img" height=40 />
        </span>
      </mat-toolbar>
      <router-outlet></router-outlet>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>
<ng-template #loginPage>
  <router-outlet></router-outlet>
</ng-template>